module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-button', _vm._b({
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clicked()
      }
    }
  }, 'b-button', _vm.$attrs, false), [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.checked
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e55570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonCheckbox.vue
// module id = 1316
// module chunks = 16